import React, { useState } from "react";
import logo from "../../../assets/logo.png";
import TextInput from "../../../components/Input/Input";
import Button from "../../../components/Button/Button";
import bgImage from "../../../assets/sideImage.jpg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Login: React.FC<any> = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const onHandleLogin = () => {
    console.log(email, password);
    if (!(email && password)) {
      toast.error("Please enter email and password", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    if (email !== "admin@freetogo.com" || password !== "Admin123") {
      toast.error("Invalid email or password", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    } else {
      localStorage.setItem("isloggedIn", "true");
      navigate("/", { replace: true });
    }
  };

  return (
    <div className="w-screen h-screen bg-primary-bg flex">
      <div className="hidden sm:flex w-[40%] overflow-hidden">
        <img src={bgImage} className="h-screen w-full object-cover" />
      </div>
      <div className="w-full md:w-[60%]  h-screen ">
        <div className="w-full bg-white p-8 h-screen flex items-center justify-center">
          <div className="w-full max-w-[25rem]">
            <img src={logo} className="m-auto mb-4" />
            <TextInput
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
            />
            <TextInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              type="password"
            />
            <Button
              variant="secondary"
              onClick={onHandleLogin}
              size="large"
              disabled={false}
              type="button"
              className={
                "hover:bg-button-hover mb-4 !w-full !bg-[#FF6200] !rounded-lg text-white transition duration-300 ease-in-out"
              }
            >
              Login
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
